import { cloneDeep } from 'lodash';

import { ServiceContractPosition } from '@work4all/models/lib/Classes/ServiceContractPosition.entity';
import { ServiceContractPositionKind } from '@work4all/models/lib/Enums/ServiceContractPositionKind.enum';

export const recalculatePositions = (data: ServiceContractPosition[]) => {
  const result: ServiceContractPosition[] = [];

  let total = 0;

  data.forEach((pos) => {
    const val = cloneDeep(pos);

    if (
      ![
        ServiceContractPositionKind.TEXTZEILE,
        ServiceContractPositionKind.UEBERSCHRIFT,
      ].includes(val.positionKind)
    ) {
      const { totalPriceNet, totalMod } = calcTotal(val);

      val.price = totalPriceNet;
      val.purchasePrice = val.price * totalMod;

      total += val.price;
    }

    result.push(val);
  });

  return { total };
};

function calcTotal(val: ServiceContractPosition) {
  const discount = val.discount ?? 0;
  const totalMod = (val.amountDecimal || 0) * (1 - discount / 100);
  const totalPriceNet = val.price * totalMod;
  return { totalPriceNet, totalMod };
}
